import { createAction, props } from '@ngrx/store';

export const init = createAction('[Navigation Page] Init');

export const stepCompleted = createAction(
  '[Navigation] Step completed',
  props<{ step: string }>()
);
